/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetShowProductVariantPriceScalesQueryResponse, GetShowProductVariantPriceScalesPathParams, GetShowProductVariantPriceScalesQueryParams, GetShowProductVariantPriceScales401, GetShowProductVariantPriceScales403, GetShowProductVariantPriceScales404 } from "../../models/GetShowProductVariantPriceScales";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetShowProductVariantPriceScalesUrl({ code }: { code: GetShowProductVariantPriceScalesPathParams["code"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${code}/variant-price-scales` as const }  
  return res
}

/**
 * {@link /api/v1/products/:code/variant-price-scales}
 */
export async function getShowProductVariantPriceScales({ code, params }: { code: GetShowProductVariantPriceScalesPathParams["code"]; params: GetShowProductVariantPriceScalesQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetShowProductVariantPriceScalesQueryResponse, ResponseErrorConfig<GetShowProductVariantPriceScales401 | GetShowProductVariantPriceScales403 | GetShowProductVariantPriceScales404>, unknown>({ method : "GET", url : getGetShowProductVariantPriceScalesUrl({ code }).url.toString(), params, ... requestConfig })  
  return res.data
}